document.addEventListener('livewire:navigated', function () {
    initializePasswordValidation();

    function initializePasswordValidation() {
        $('.live-password-validation').each(function () {
            var $passwordField = $(this).find('input[name="password"]');
            var container = $(this);

            $passwordField.off('keyup change').on('keyup change', function () {
                var pw = $passwordField.val();

                // pw length
                if (pw.length >= 8) {
                    container.find('.password-length').removeClass('invalid').addClass('success');
                } else {
                    container.find('.password-length').removeClass('success').addClass('invalid');
                }

                // pw mixed case
                if (pw.match(/[a-z]/) && pw.match(/[A-Z]/)) {
                    container.find('.password-mixed-case').removeClass('invalid').addClass('success');
                } else {
                    container.find('.password-mixed-case').removeClass('success').addClass('invalid');
                }
            }).change();
        });
    }
});
